<template>
  <div id="app" class="h-screen">
    <nav></nav>
    <div v-if="!loading" class="h-full" ref="mainContainer">
      <router-view v-bind:bgColor="randomBg" :textColor="randomText" />
    </div>
    <div v-else>
      <div class="espera"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      randomBg: "",
      randomText: "",
    };
  },
  beforeMount() {
    const calculateLuminance = (r, g, b) => {
      const normalize = (value) =>
        value / 255 <= 0.03928
          ? value / 255 / 12.92
          : Math.pow((value / 255 + 0.055) / 1.055, 2.4);
      return (
        0.2126 * normalize(r) + 0.7152 * normalize(g) + 0.0722 * normalize(b)
      );
    };

    const calculateContrast = (color1, color2) => {
      const lum1 = calculateLuminance(color1.r, color1.g, color1.b);
      const lum2 = calculateLuminance(color2.r, color2.g, color2.b);
      const [L1, L2] = lum1 > lum2 ? [lum1, lum2] : [lum2, lum1];
      return (L1 + 0.05) / (L2 + 0.05);
    };

    let backgroundColor, textColor, contrast;
    do {
      backgroundColor = {
        r: Math.floor(Math.random() * 256),
        g: Math.floor(Math.random() * 256),
        b: Math.floor(Math.random() * 256),
      };

      textColor = {
        r: Math.floor(Math.random() * 256),
        g: Math.floor(Math.random() * 256),
        b: Math.floor(Math.random() * 256),
      };

      contrast = calculateContrast(backgroundColor, textColor);
    } while (contrast >= 5.3);

    this.randomBg = `rgb(${backgroundColor.r}, ${backgroundColor.g}, ${backgroundColor.b})`;
    this.randomText = `rgb(${textColor.r}, ${textColor.g}, ${textColor.b})`;

    document.body.style.backgroundColor = this.randomBg;
    document.body.style.color = this.randomText;
  },
  methods: {
    hideMainContainer() {
      const container = this.$refs.mainContainer;
      if (container) {
        container.style.display = "none";
      }
    },
    showMainContainer() {
      const container = this.$refs.mainContainer;
      if (container) {
        container.style.display = "block";
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.hideMainContainer);
    window.addEventListener("keyup", this.showMainContainer);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.hideMainContainer);
    window.removeEventListener("keyup", this.showMainContainer);
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Galada&family=Limelight&family=Markazi+Text:wght@400..700&family=Special+Elite&family=Syne+Mono&display=swap");
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: randomBg;
}

body {
  margin: 0;
}
</style>
